import { Content } from './loader.styled';

export const Loader = (props) => {
  return <Content {...props} />;
};
